import { render, staticRenderFns } from "./OnboardingMainPage.vue?vue&type=template&id=323ea3c2"
import script from "./OnboardingMainPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingMainPage.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingMainPage.vue?vue&type=style&index=0&id=323ea3c2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports